import React from "react";
import "./css/Header.css";
import Logo from "../assets/images/velarimg.png";
import HeaderBottom from "./HeaderBottom";

const Header = () => {
  return (
    <>

      <div className="bg-black text-white py-2 border-bottom "data-sal='fade' data-sal-duration="2000" data-sal-delay="300">
      <div className="container-fluid d-flex justify-content-between align-items-center">
  {/* Logo Section */}
  <div className="d-flex align-items-center" data-sal="slide-right" data-sal-duration="2000" data-sal-delay="300">
    <div className="d-flex align-items-center">
      <a href="/">
        <img
          className="img-fluid ms-2"
          src={Logo} 
          alt="Velar Heights Logo"
          style={{
            height: "100px",
            width: "200px",
            maxWidth: "300px",
            marginRight: "10px",
            display: "block",
          }}
        />
      </a>
    </div>
  </div>

  {/* Contact Section */}
  <div className="d-flex align-items-center p-3" data-sal="slide-left" data-sal-duration="700" data-sal-delay="200">
    <i className="bi bi-headset fs-1 me-3 text-light"></i>
    <div className="text-start">
      <small className="d-block fw-bold fs-6" style={{ color: "#c5a15e" }}>
        Call Now
      </small>
      <a href="tel:+16472474110" style={{ textDecoration: "none", color: "#fff" }}>
        <span className="fw-bold fs-4">+1 647-247-4110</span>
      </a>
    </div>
  </div>
</div>

      </div>


      <HeaderBottom />
    </>
  );
};

export default Header;
